// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae371775","455":"fabf4b19","977":"1979d60b"}[chunkId] + ".chunk.js";
};